// extracted by mini-css-extract-plugin
export default {"project-update-modal-form":"style_project-update-modal-form__zKItx","form-wrapper":"style_form-wrapper__dMSMY","field-wrapper":"style_field-wrapper__-9Zg8"};